'use client';

import { EntityProcedureScheduleCard } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedure-schedule-card.component';
import { EntityProcedurePlaceCard } from '@/app/(main)/(pages)/_components/entities/entity-procedure/_components/entity-procedure-place-card.component';
import { EntityProceduresSection } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedures-section.component';
import { UseProfessionalProceduresReturn } from '@/app/(main)/(pages)/(institucional)/(index)/profissionais/[slug]/_hooks/use-professional-procedures.hook';
import { EntityProceduresAnalytics } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedures-section.component';
import { SearchApiServiceChannel } from '@/app/(main)/(pages)/_types/search-api-response.type';
import { ScheduleTabOrigin } from '@/types/enums/analytics/search/search-analytics.enum';
import { CHANNEL_MODALITY, ScheduleTabAnalytics } from '@/app/(main)/(pages)/busca/[slug]/_utils/schedule-tab-analytics.util';
import { EntityAnalyticsProperties } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedure-analytics.type';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

const PROFESSIONAL_CHANNEL_TABS = {
  [SearchApiServiceChannel.IN_PERSON]: AnalyticsEnum.PROFESSIONAL_PROFILE_CLICK_IN_PERSON_TAB,
  [SearchApiServiceChannel.TELEHEALTH]: AnalyticsEnum.PROFESSIONAL_PROFILE_CLICK_TELEHEALTH_TAB,
};

interface ProfessionalSchedulesSectionProps {
  procedures: UseProfessionalProceduresReturn;
  professionalId: string;
  className?: string;
  scrollTargetId?: string;
}

export function ProfessionalSchedulesSection({
  procedures,
  professionalId,
  className,
  scrollTargetId,
}: ProfessionalSchedulesSectionProps) {
  const entityProperties: EntityAnalyticsProperties = {
    entity: professionalId,
    entityType: EntityTypeEnum.PROFESSIONAL,
  };
  const analytics: EntityProceduresAnalytics = {
    channelTabs: PROFESSIONAL_CHANNEL_TABS,
    seeMore: AnalyticsEnum.PROFESSIONAL_PROFILE_CLICK_SEE_MORE_PROCEDURES,
    properties: entityProperties,
  };
  const tabAnalytics: ScheduleTabAnalytics = {
    origin: ScheduleTabOrigin.PROFESSIONAL_PROFILE,
    modalidade: CHANNEL_MODALITY[procedures.activeChannel],
    ...entityProperties,
  };

  return (
    <EntityProceduresSection
      procedures={procedures}
      title="Consultas e horários"
      className={className}
      scrollTargetId={scrollTargetId}
      analytics={analytics}
      renderProcedure={(procedure, index) => (
        <EntityProcedureScheduleCard
          key={procedure.id}
          accordionKey={procedure.id}
          title={procedure.name}
          defaultOpen={index === 0}
          analyticsExpandEvent={AnalyticsEnum.PROFESSIONAL_PROFILE_EXPAND_PROCEDURE}
          analyticsExpandProperties={{ ...entityProperties, procedure_id: procedure.id }}
        >
          {procedure.places.map((place) => (
            <EntityProcedurePlaceCard key={place.id} place={place} tabAnalytics={tabAnalytics} />
          ))}
        </EntityProcedureScheduleCard>
      )}
    />
  );
}
